import React from "react";
import { Box, Typography, CardActionArea } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const PatternForm = ({ selectedPattern, onPatternChange, patterns }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const getCdnUrl = (url) => {
    return url.replace(
      "https://usipanel-bucket-textures.s3.fr-par.scw.cloud/",
      "https://usipanel.b-cdn.net/"
    );
  };

  return (
    <Box
      sx={{
        paddingRight: "20px",
        paddingLeft: "20px",
      }}
    >
      <Typography
        variant="h3"
        gutterBottom
        align="center"
        sx={{
          fontSize: { xs: "1rem", sm: "1.5rem", md: "2rem", lg: "2rem" },
          paddingBottom: { xs: "0px", md: "30px" },
        }}
      >
        Choisir mon motif
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: isXs ? "nowrap" : "wrap",
          overflowX: isXs ? "auto" : "visible",
          justifyContent: isXs ? "normal" : "center",
          gap: isXs ? 2 : 3,
          maxHeight: { xs: "unset", md: "50vh" },
          overflowY: { xs: "unset", md: "auto" },
          position: { md: "sticky" },
        }}
      >
        {patterns.map((pattern) => (
          <Box
            key={pattern.id}
            sx={{ textAlign: "center", paddingBottom: "20px" }}
          >
            <CardActionArea
              onClick={() =>
                onPatternChange({ target: { value: pattern.id } })
              }
              sx={{
                width: isXs ? "80px" : "130px",
                height: isXs ? "80px" : "130px",
                flex: "0 0 auto",
                borderRadius: 2,
                overflow: "hidden",
                position: "relative",
                border:
                  String(selectedPattern) === String(pattern.id)
                    ? "2px solid ${theme.palette.custom.blue}"
                    : "2px solid transparent",
                transition: "border-color 0.3s ease-in-out",
                "&:hover img": {
                  opacity: 1,
                },
                "&:hover": {
                  borderColor: theme.palette.custom.blue,
                },
              }}
            >
              <Box
                component="img"
                src={getCdnUrl(pattern.url)}
                alt={pattern.name}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  opacity: 0.25,
                  transition: "opacity 0.3s ease-in-out",
                }}
              />
              {String(selectedPattern) === String(pattern.id) && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    bgcolor: "rgba(25, 118, 210, 0.7)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      display: "block",
                      whiteSpace: "nowrap",
                      fontWeight: 900,
                      textTransform: "uppercase",
                      textAlign: "center",
                      fontStyle: "italic",
                      fontSize: isXs ? "10px" : "13px",
                      color: "#fff",
                    }}
                  >
                    {pattern.name}
                  </Typography>
                </Box>
              )}
            </CardActionArea>
            {String(selectedPattern) !== String(pattern.id) && (
              <Typography
                variant="subtitle1"
                sx={{
                  display: "block",
                  whiteSpace: "nowrap",
                  fontWeight: "bold",
                  fontFamily:
                    "'Fira Sans', Helvetica, Arial, Lucida, sans-serif",
                  textTransform: "uppercase",
                  fontSize: "13px",
                  mt: 1,
                }}
              >
                {pattern.name}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PatternForm;
